export default class NumberFormatterHelper {
    static getFormattedNumber(value) {
        value = parseFloat(value).toLocaleString('en-US', {
            minimumFractionDigits: 1,
            maximumFractionDigits: 6
        })
        return `${value}`
    }
}
